import React from "react";
import { useSettings } from "@/App";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { LogoEmblem } from "@/components/Logo";

export default function About() {
  const { settings } = useSettings();
  const a = settings?.content?.about || {};
  const eyebrow = a.eyebrow || "About";
  const heading = a.heading || "A discreet, premium international sourcing house.";
  const paragraphs = a.paragraphs?.length ? a.paragraphs : [
    "Goldstone Sourcing is a specialist sourcing business connecting investors, businesses and buyers with carefully identified opportunities across selected markets. We search against defined requirements rather than presenting available inventory.",
    "Our focus is property and real estate, complemented by bespoke sourcing mandates, commercial opportunities and strategic materials and equipment sourcing.",
  ];
  const highlights = a.highlights?.length ? a.highlights : [
    { k: "Focus", v: "Property-led, multi-discipline" },
    { k: "Model", v: "Mandate-driven sourcing" },
    { k: "Markets", v: "Selected international" },
    { k: "Approach", v: "Confidential & curated" },
  ];

  return (
    <div className="min-h-screen bg-obsidian px-6 pt-32 pb-24 lg:px-10" data-testid="about-page">
      <div className="mx-auto max-w-4xl">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-5 font-serif text-4xl leading-tight text-warmwhite lg:text-6xl">{heading}</h1>
        </Reveal>

        <div className="mt-10 flex justify-center">
          <LogoEmblem size={160} spin />
        </div>

        <Reveal delay={0.1}>
          <div className="mt-12 space-y-6 font-sans text-base leading-relaxed text-softgrey">
            {paragraphs.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </Reveal>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {highlights.map((s, i) => (
            <div key={i} className="border border-gold/15 bg-seablue/15 p-6">
              <div className="font-sans text-[10px] tracking-luxe uppercase text-gold">{s.k}</div>
              <div className="mt-2 font-serif text-lg text-warmwhite">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
